import { defineEffect } from '../../../core/effect';
import { posChangeMotionSpec } from '../fx/posChange';

/** 魔法・罠の表裏（浮いて開く。パネル無し）（Issue #589。状況は共通側の `editorPorts/duelSituations/pos_change.js` が決め、絵の組み立ては `../fx/posChange.js`） */
export default defineEffect({ situation: 'pos_change_spell', role: 'motion', ...posChangeMotionSpec('spell') }, 'pos_change_spell_motion.js');
